import { ReactNode } from "react";

type PageHeroProps = {
  eyebrow?: string;
  title: string;
  body: string;
  image?: string;
  children?: ReactNode;
};

export function PageHero({ eyebrow, title, body, image, children }: PageHeroProps) {
  return (
    <section className="page-hero" data-reveal>
      {image ? <img className="page-hero-image" src={image} alt="" aria-hidden="true" /> : null}
      <div className="section-inner page-hero-inner">
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <h1>{title}</h1>
        <p className="page-hero-copy">{body}</p>
        {children}
      </div>
    </section>
  );
}
